import Swal from 'sweetalert2'

import CONST_COMPONENT from '../../const/component'

export const showReferenceModalElementsIfActionButtonHasSpecificValue = (connection) => {
  const nodeInput = connection.input.node
  const nodeOutput = connection.output.node

  if (
    (CONST_COMPONENT.ACTION_BUTTON === nodeOutput.name) 
    && (CONST_COMPONENT.POSTBACK === nodeInput.name)
  ) {
    if (('get-started' === nodeOutput.data.actionType) 
      || ('messenger_engagement_plugin' === nodeOutput.data.actionType)
    ) {

      // Hides elements on modal if it is open
      toggleModalElements(nodeInput, 'show')
    }
  }
}

export const hideReferenceModalElementsIfActionButtonHasSpecificValue = (connection) => {
  const nodeInput = connection.input.node
  const nodeOutput = connection.output.node

  if (
    (CONST_COMPONENT.ACTION_BUTTON === nodeOutput.name) 
    && (CONST_COMPONENT.POSTBACK === nodeInput.name)
  ) {
    if (('get-started' === nodeOutput.data.actionType) 
      || ('messenger_engagement_plugin' === nodeOutput.data.actionType)
    ) {

      // Displays hidden elements on modal if it is open
      toggleModalElements(nodeInput, 'hide')
    }
  }
}

const toggleModalElements = (node, showHide) => {
  if (Swal.isVisible()) {  
    const nodeClass = '.node-id-' + node.id
    const parentElement = $(nodeClass).find('#reference-choose-sequence').parent()

    if ('show' === showHide) {
      parentElement.removeClass('d-none').addClass('d-block')
    } else if ('hide' === showHide) {
      parentElement.removeClass('d-block').addClass('d-none')
    }
  }
}